import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { SERVICES } from '../../data';

const Services = () => {
    return (
        <section id="services" className="py-32 px-6 md:px-12 bg-[#050505] text-[#fbfbf4]">
            <h2 className="font-migra text-5xl md:text-8xl mb-24 text-center">Capabilities</h2>
            <div className="space-y-0">
                {SERVICES.map((service, i) => (
                    <motion.div
                        key={service.id}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: i * 0.1, duration: 0.8 }}
                        className="group relative border-t border-white/10 py-16 md:py-24 hover:bg-white/5 transition-colors duration-500"
                    >
                        <div className="flex flex-col md:flex-row justify-between items-start md:items-center relative z-10">
                            <div className="mb-6 md:mb-0 md:w-1/3">
                                <span className="text-xs font-mono opacity-50 mr-4">({service.id})</span>
                                <h3 className="font-migra text-4xl md:text-5xl inline-block group-hover:italic transition-all">{service.title}</h3>
                            </div>
                            <div className="md:w-1/3 md:pl-12">
                                <p className="text-sm opacity-60 leading-relaxed">{service.desc}</p>
                            </div>
                            <div className="mt-6 md:mt-0 md:w-1/6 flex justify-end">
                                <ArrowRight className="opacity-50 md:opacity-0 md:-translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500" />
                            </div>
                        </div>

                        {/* Hover Image Reveal */}
                        <img
                            src={service.image}
                            alt=""
                            className="hidden md:block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[30vw] h-[20vw] object-cover opacity-0 group-hover:opacity-20 pointer-events-none transition-opacity duration-500 blur-sm mix-blend-screen"
                        />
                    </motion.div>
                ))}
            </div>
        </section>
    );
};

export default Services;
